import { filter, map } from 'lodash/fp';
import { createSelector } from 'reselect';
import { createAsyncActionTypes, createAction } from '@mews/framework';
import { getStringProp } from '@mews/fp';
import { ApplicationState, AsyncAction, CommanderThunkAction } from '@mews-commander/types';
import { RoutingRuleAssignment } from '@mews-commander/data-access';
import { createFetchAction } from '@mews-commander/utils';
import parentSelector from '../selector';
import prefix from '../prefix';
import { createScopedEntitiesReducer, createScopedBaseEntitySelectors } from './utils';

export const NAME = 'routingRuleAssignments';

export const ROUTING_RULES_ASSIGNMENTS_FETCH = prefix('ROUTING_RULES_ASSIGNMENTS_FETCH');
export const [
    ROUTING_RULES_ASSIGNMENTS_FETCH_STARTED,
    ROUTING_RULES_ASSIGNMENTS_FETCH_SUCCEEDED,
    ROUTING_RULES_ASSIGNMENTS_FETCH_FAILED,
] = createAsyncActionTypes(ROUTING_RULES_ASSIGNMENTS_FETCH);
export const ROUTING_RULES_ASSIGNMENTS_DELETE = prefix('ROUTING_RULES_ASSIGNMENTS_DELETE');
export const [
    ROUTING_RULES_ASSIGNMENTS_DELETE_STARTED,
    ROUTING_RULES_ASSIGNMENTS_DELETE_SUCCEEDED,
    ROUTING_RULES_ASSIGNMENTS_DELETE_FAILED,
] = createAsyncActionTypes(ROUTING_RULES_ASSIGNMENTS_DELETE);

export const deleteRoutingRuleAssignments =
    ({
        routingRuleAssignmentIds,
        enterpriseId,
    }: {
        routingRuleAssignmentIds: string[];
        enterpriseId: string;
    }): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories }) => {
        const promise = repositories.routingRuleAssignments
            .delete({ routingRuleAssignmentIds, enterpriseId })
            .then(() => routingRuleAssignmentIds);

        return dispatch(createFetchAction(ROUTING_RULES_ASSIGNMENTS_DELETE, promise, { scope: enterpriseId }));
    };

export const [
    getRoutingRuleAssignments,
    getRoutingRuleAssignmentsByIds,
    getRoutingRuleAssignmentsByOwnerId,
    getRoutingRuleAssignment,
] = createScopedBaseEntitySelectors<ApplicationState, RoutingRuleAssignment, typeof NAME, 'enterpriseId'>(
    parentSelector,
    NAME,
    'enterpriseId'
);

export const getRoutingRuleAssignmentsByRuleId = createSelector(
    getRoutingRuleAssignments,
    getStringProp('routingRuleId'),
    (assignments, routingRuleId) => filter({ routingRuleId }, assignments)
);

export const getRoutingRuleAssignmentIds = createSelector(getRoutingRuleAssignmentsByRuleId, map('id'));

export const setRoutingRuleAssignments = (entities: RoutingRuleAssignment[], scope: string) =>
    createAction(ROUTING_RULES_ASSIGNMENTS_FETCH_SUCCEEDED, { entities }, { scope });

export const routingRuleAssignmentsReducer = createScopedEntitiesReducer({
    FETCH_SUCCESS: ROUTING_RULES_ASSIGNMENTS_FETCH_SUCCEEDED,
    DELETE_SUCCESS: ROUTING_RULES_ASSIGNMENTS_DELETE_SUCCEEDED,
});
